import {str} from 'evite';

// matching validation logic in /typhoon/assets/js/common/utils.js
export const validateEmail = (email, allowEmpty) => {
  const MAX_EMAIL_LENGTH = 254;

  let cleanEmail = str(email).trim();
  cleanEmail = cleanEmail.replace(/^[\s(<{[]+/, '');
  cleanEmail = cleanEmail.replace(/[\s)>}\]]+$/, '');

  if (!cleanEmail && allowEmpty) {
    return {valid: true, value: ''};
  }

  if (!cleanEmail && !allowEmpty) {
    return {valid: false, message: 'Email address is required'};
  }

  if (cleanEmail.length > MAX_EMAIL_LENGTH) {
    return {
      valid: false,
      message: `Email address max length is ${MAX_EMAIL_LENGTH}`,
    };
  }

  // to match backEnd validation
  // Server enforced regex
  const serverRegex =
    /(^\s*[a-zA-Z0-9."!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9_-]+\.[a-zA-Z0-9-.]+\s*$)/gm;
  // Browser enforced regex
  const browserRegex =
    /^[a-zA-Z0-9.!#$%&'*+\\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/gm;
  const isValidFormat = browserRegex.test(cleanEmail) && serverRegex.test(cleanEmail);

  if (!isValidFormat) {
    return {valid: false, message: 'Invalid email address'};
  }

  return {valid: true, value: cleanEmail};
};
